import { useState, type ReactNode } from 'react';
import { useGame } from '../../state/GameContext.js';
import { Header } from './Header.js';
import { Sidebar } from './Sidebar.js';

export const AppLayout = ({ children }: { children: ReactNode }) => {
  const [menu, setMenu] = useState(false);
  const { status } = useGame();
  return <div className="app-shell"><Sidebar open={menu} onClose={() => setMenu(false)} /><div className="app-main"><Header onMenu={() => setMenu(true)} /><main className="page-container">{children}</main><div className="statusbar" role="status">{status}</div></div></div>;
};
